<script lang="ts" context="module">
  let id = 0;
  export function getId() {
    return `utheory-stylable-select-${id++}`;
  }
</script>

<script lang="ts">
  import MaterialIcon from '$lib/MaterialIcon.svelte';
  import { mdiChevronDown } from '@mdi/js';
  import { createEventDispatcher, onMount } from 'svelte';
  import { twMerge } from 'tailwind-merge';

  type T = $$Generic;
  interface $$Props {
    value: T;
    options: {
      title: string;
      value: T;
    }[];
    class?: string;
    wrapperClass?: string;
  }

  interface $$Slots {
    default: never;
    chevron: true;
  }

  const id = getId();
  export let value: T;
  export let options: {
    title: string;
    value: T;
  }[];
  let clazz = '';
  export { clazz as class };
  export let wrapperClass = '';

  const dispatch = createEventDispatcher();

  $: selectedOption = options.find((o) => o.value === value);
  let select: HTMLSelectElement;
  let label: HTMLLabelElement;
  let width: number = 50;

  function resize() {
    const { width: newWidth } = label.getBoundingClientRect();
    width = newWidth;
    // select.style.width = `${newWidth}px`;
  }

  onMount(resize);
  let focused = false;
</script>

<div class={twMerge('relative inline', wrapperClass)} style="min-width: {width}px;">
  <label bind:this={label} aria-hidden class={twMerge('w-fit', clazz)} for={id}>
    <span class:underline={focused}
      >{selectedOption ? selectedOption.title : 'Choose among the following...'}</span
    >
    {#if $$slots.chevron}
      <slot name="chevron" />
    {:else}
      <MaterialIcon path={mdiChevronDown} class="pl-1" />
    {/if}
  </label>
  <select
    style="width: {width}px;"
    on:focus={() => {
      focused = true;
    }}
    on:blur={() => {
      focused = false;
    }}
    {id}
    bind:value
    on:change={(evt) => {
      resize();
      dispatch('change', evt);
    }}
    bind:this={select}
  >
    {#each options as option}
      <option value={option.value}>{option.title}</option>
    {/each}
  </select>
</div>

<style lang="postcss">
  select {
    @apply cursor-pointer;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    padding-right: 1em;
  }
</style>
